// apps/landing-page/src/components/search/SearchButton.tsx
'use client';

import { Search } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { cn } from '@/lib/utils';

// Icon trigger for the modal dialog (below xl). data-search-trigger lets the dialog find
// a visible trigger to give focus back to when it was opened with Ctrl+K.
export function SearchButton({ onClick, className }: { onClick: () => void; className?: string }) {
  const t = useTranslations('search');
  return (
    <button
      type="button"
      onClick={onClick}
      data-search-trigger
      aria-haspopup="dialog"
      aria-keyshortcuts="Control+K Meta+K"
      aria-label={t('placeholder')}
      className={cn('flex h-10 w-10 items-center justify-center rounded-lg text-slate-600 transition-colors hover:bg-slate-100', className)}
    >
      <Search className="h-5 w-5" />
    </button>
  );
}
